module.exports = __webpack_public_path__ + "img/640_clj.fdc6fb3e.png";